//=========================================================================
// Product Utility functions
//-------------------------------------------------------------------------
// Author: Robert Rolland
// Date: March 25, 2022
// Description:
//     This file contains simple product related utility functions that
//     are called from diverse elements of the application
//=========================================================================

import { I18n } from "@aws-amplify/core";

export const calcProductState = (blocked, deleted, obsolete) => {
    let productStates = [];
    if (blocked) productStates.push(I18n.get("product_state_blocked"));
    if (deleted) productStates.push(I18n.get("product_state_deleted"));
    if (obsolete) productStates.push(I18n.get("product_state_obsolete"));
    if (!blocked && !deleted && !obsolete) productStates.push(I18n.get("product_state_active"));
    return productStates.join(", ");
}
